import React from 'react'

// start import for materialUI
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
// end import for materialUI


const AlertDialog = ({
    // show/hide this AlertComponent
    showAlert,
    // title of Alert
    title,
    // main text of Alert
    description,
    // text of button (accept message)
    acceptButtonText,
    // text of button (reject message)
    rejectButtonText,
    // Function of accept Button
    acceptButtonFunction,
    // Function of reject Button
    rejectButtonFunction }) => {

    return (
        <Dialog
            open={showAlert}
            // TransitionComponent={true}
            keepMounted
            onClose={rejectButtonFunction}
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    {description}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={rejectButtonFunction}>{rejectButtonText}</Button>
                <Button onClick={acceptButtonFunction}>{acceptButtonText}</Button>
            </DialogActions>
        </Dialog>
    )
}

export default AlertDialog